import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmWelfareWhiteAdd, gmWelfareWhiteUpd, gmWelfareLevelLists } from '@/api/gmtool/packageCode';
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    serverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      paramsData: {
        id: '',
        user_id: '',
        device_id: '',
        ip: '',
        welfare_level_id: '',
        input: '',
        textarea: ''
      },
      gmWelfareLevelListsList: [],
      dialogShow: false,
      rules: {
        user_id: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        device_id: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        ip: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        welfare_level_id: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        input: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        textarea: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      this.getLists();

      if (data) {
        this.paramsData = _objectSpread(_objectSpread({}, this.paramsData), data);
      }

      this.dialogShow = true;
    },
    getLists: function getLists() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return gmWelfareLevelLists(_this.prod);

              case 2:
                _this.gmWelfareLevelListsList = _context.sent.data;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        id: isClearId ? '' : this.paramsData.id,
        user_id: '',
        device_id: '',
        ip: '',
        welfare_level_id: '',
        input: '',
        textarea: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.paramsData.id !== '' ? gmWelfareWhiteUpd : gmWelfareWhiteAdd;
          reqFn(_objectSpread(_objectSpread({}, _this2.paramsData), _this2.prod)).then(function (res) {
            if (res.status == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('update');
            }
          });
        }
      });
    }
  }
};